/*
* Developed for G.J. Gardner Homes by Softeq Development Corporation
* http://www.softeq.com
*/

import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { ID } from '@gh/common-shared-data';
import { GraphicalTakeOffTop } from '../../resources';

/**
 * Clone view component
 */
@Component({
  selector: 'gh-graphical-take-off-clone',
  template: require('./graphical-take-off-clone.component.html'),
  styles: [require('./graphical-take-off-clone.component.scss')],
})
export class GraphicalTakeOffCloneComponent {
  /**
   * Clone TOP
   *
   * @type {GraphicalTakeOffTop}
   */
  cloneTopId: ID;

  /**
   * Constructor
   *
   * @param {any} data - Dialog data
   * @param {MatDialogRef<GraphicalTakeOffCloneComponent>} dialogRef - Dialog ref
   * @returns {void}
   */
  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    private dialogRef: MatDialogRef<GraphicalTakeOffCloneComponent>,
  ) {
  }

  /**
   * Close dialog
   *
   * @returns {void}
   */
  close(): void {
    this.dialogRef.close();
  }

  /**
   * Apply clone
   *
   * @returns {void}
   */
  apply(): void {
    this.dialogRef.close(this.cloneTopId);
  }
}
